// extracted by mini-css-extract-plugin
export default {"transfer":"TransferDialog_transfer__3Fgz7"};